import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from './redux';
import {
  login,
  signup,
  logout,
  getCurrentUser,
  registerUser,
  registerPartner,
  updateProfile,
  clearError,
  clearRegistrationSuccess,
  verifyEmail,
  resendVerification
} from '../store/slices/authSlice';
import { LoginCredentials, SignupCredentials } from '../types';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const { user, isAuthenticated, isLoading, error, token, registrationSuccess } = useAppSelector(
    (state: any) => state.auth
  );

  const loginUser = useCallback(async (credentials: LoginCredentials) => {
    return dispatch(login(credentials)).unwrap();
  }, [dispatch]);

  const signupUser = useCallback(async (credentials: SignupCredentials) => {
    return dispatch(signup(credentials)).unwrap();
  }, [dispatch]);

  const logoutUser = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  const fetchCurrentUser = useCallback(() => {
    if (token) {
      dispatch(getCurrentUser());
    }
  }, [dispatch, token]);

  const clearAuthError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const registerUserAccount = useCallback(async (userData: any) => {
    return dispatch(registerUser(userData)).unwrap();
  }, [dispatch]);

  const registerPartnerAccount = useCallback(async (partnerData: any) => {
    return dispatch(registerPartner(partnerData)).unwrap();
  }, [dispatch]);

  const verifyEmailAccount = useCallback(async (data: { email: string; otp: string }) => {
    return dispatch(verifyEmail(data)).unwrap();
  }, [dispatch]);

  const resendVerificationEmail = useCallback(async (data: { email: string }) => {
    return dispatch(resendVerification(data)).unwrap();
  }, [dispatch]);

  const clearRegistrationSuccessFlag = useCallback(() => {
    dispatch(clearRegistrationSuccess());
  }, [dispatch]);

  const updateUserProfile = useCallback(async (userData: any) => {
    return dispatch(updateProfile(userData)).unwrap();
  }, [dispatch]);

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    token,
    registrationSuccess,
    loginUser,
    signupUser,
    logoutUser,
    fetchCurrentUser,
    clearAuthError,
    registerUser: registerUserAccount,
    registerPartner: registerPartnerAccount,
    verifyEmail: verifyEmailAccount,
    resendVerification: resendVerificationEmail,
    updateProfile: updateUserProfile,
    clearRegistrationSuccess: clearRegistrationSuccessFlag,
  };
};
